import { Modal } from '@components/modal/Modal';
import { useModal } from '@components/modal/ModalProvider';
import toast from 'react-hot-toast';
import { useI18nContext } from '../../i18n/i18n-react';
import { useShareActions } from '../../data/share/shareActions';

export const RegeneratePublicKeysConfirmationModal = ({ shareIds: shareIds }: { shareIds: number[] }) => {
    const { LL } = useI18nContext();
    const { hideModal } = useModal();
    const {
        state: { loading: apiLoading },
        api: { regeneratePublicKeys },
    } = useShareActions();

    const regenerate = async () => {
        const loadingId = toast.loading(LL.REGENERATING_LINKS());

        const mutationOptions = {
            onSuccess() {
                toast.dismiss(loadingId);
                toast.success(LL.REGENERATED());
                hideModal();
            },
            onError() {
                toast.dismiss(loadingId);
                toast.error(LL.FAILED_REGENERATING_LINKS());
            },
        };

        await regeneratePublicKeys(shareIds, mutationOptions);
    };

    return (
        <Modal.Content width={500}>
            <Modal.Header title={LL.REGENERATING_LINKS_SELECTED_ASSIGNMENTS()} />
            <Modal.Body>
                <Modal.Paragraph>{LL.REGENERATING_LINKS_SELECTED_ASSIGNMENTS_CONFIRMATION()}</Modal.Paragraph>
            </Modal.Body>
            <Modal.Footer loading={apiLoading} done={regenerate} doneLabel={LL.REGENERATE()} />
        </Modal.Content>
    );
};
